import { Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import KnowMorePage from "./components/KnowMorePage";
import AboutKropsCapital from "./components/AboutKropsCapital";
import ContactPage from "./components/ContactPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/know-more" element={<KnowMorePage />} />
        <Route path="/about" element={<AboutKropsCapital />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </>
  );
}

export default App;









